'use strict';

exports.distance = require('./distances');
exports.similarity = require('./similarities');


//////////////////
// WEBPACK FOOTER
// ./~/ml-distance/src/index.js
// module id = 18
// module chunks = 0